import { createTheme, MantineTheme } from '@mantine/core'
import { colors } from '@/app/colors'

const COMPONENTS = ['Accordion', 'Paper']

const COMPONENT_STYLES: React.CSSProperties = {
  borderColor: 'var(--mantine-color-default-border)',
}

const TOOLTIP_STYLES: React.CSSProperties = {
  fontSize: '0.75rem',
  borderRadius: '0.5rem',
  boxShadow: 'var(--mantine-shadow-md)',
  color: 'light-dark(var(--mantine-color-dark-7), var(--mantine-color-white))',
  backgroundColor: 'light-dark(var(--mantine-color-white), var(--mantine-color-dark-7))',
  border: '1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4))',
}

const formatStyles = (style: React.CSSProperties) => (_theme: MantineTheme, params: { variant?: string }) => {
  if (params?.variant === 'unstyled') return {}
  return {
    item: style,
    root: style,
  }
}

export const mantineTheme = createTheme({
  primaryColor: 'primary',
  colors,
  primaryShade: {
    light: 6,
    dark: 4,
  },
  black: colors.zinc[10],
  components: {
    ...Object.fromEntries(COMPONENTS.map((name) => [name, { styles: formatStyles(COMPONENT_STYLES) }])),
    Tooltip: {
      styles: () => ({
        tooltip: TOOLTIP_STYLES,
      }),
    },
  },
})
